import { MONTH as month, WEEK as week } from 'Lib/constants/time';

export const WEEK = week;
export const MONTH = month;

export const unitToShorthandIdMapping = {
  [WEEK]: 'durationUnitWeekShort',
  [MONTH]: 'durationUnitMonthShort',
};
